import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "employeeSelect",
    "currentMonth",
    "lastMonth",
    "totalHours",
    "statsContainer",
    "loading",
  ]
  static values = { url: String }

  connect() {
    if (this.hasEmployeeSelectTarget && this.employeeSelectTarget.value) {
      this.loadStats()
    }
  }

  employeeChanged() {
    this.loadStats()
  }

  async loadStats() {
    const employeeId = this.employeeSelectTarget.value
    if (!employeeId) {
      this.hideStats()
      return
    }

    this.showLoading()

    try {
      const response = await fetch(`${this.urlValue}?employee_id=${employeeId}`, {
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
      })

      if (response.ok) {
        const data = await response.json()
        this.updateStats(data)
        this.showStats()
      } else {
        console.error("Failed to load time account stats")
        this.hideStats()
      }
    } catch (error) {
      console.error("Error loading time account stats:", error)
      this.hideStats()
    } finally {
      this.hideLoading()
    }
  }

  updateStats(data) {
    if (this.hasCurrentMonthTarget) {
      this.currentMonthTarget.textContent = this.formatHours(data.current_month)
    }
    if (this.hasLastMonthTarget) {
      this.lastMonthTarget.textContent = this.formatHours(data.last_month)
    }
    if (this.hasTotalHoursTarget) {
      this.totalHoursTarget.textContent = this.formatHours(data.total)
    }
  }

  formatHours(value) {
    if (value === null || value === undefined) return "0.0"
    return value.toFixed(1)
  }

  showStats() {
    if (this.hasStatsContainerTarget) {
      this.statsContainerTarget.classList.remove("hidden")
    }
  }

  hideStats() {
    if (this.hasStatsContainerTarget) {
      this.statsContainerTarget.classList.add("hidden")
    }
  }

  showLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.remove("hidden")
    }
  }

  hideLoading() {
    if (this.hasLoadingTarget) {
      this.loadingTarget.classList.add("hidden")
    }
  }
}
